/**
 * Name of Background Shape
 */
export var BACKGROUND_SHAPE = 'element-background';
//# sourceMappingURL=constant.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g2/esm/geometry/shape/constant.js
// module id = null
// module chunks = 